import _ from "lodash";
import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import classNames from "classnames";

import ProfileCascade from "UIComponents/ProfileCascade";
import { useI18n } from "Hooks";
import {
  getDefaultNameSortPreference,
  getDefaultStudentNameOrderPreference,
} from "modules/CommonSelectors";
import {
  recipientModalPaddingStyles,
  getSubText,
  getFormattedNameForUserType,
} from "Utils/MessageHelpers";
import { getUserInfo } from "Login/modules/LoginModule/LoginUtils";

import classes from "./RecipientsList.scss";

const avatarStyles = {
  size: "small",
  randomizeColor: true,
  shade: "light",
  shape: "square",
};

const profileCascadeContainerStyle = { flexShrink: "0" };

const RecipientsList = props => {
  const {
    data,
    defaultNameSortPreference,
    loggedInUserType,
    defaultStudentNameOrderPreference,
  } = props;
  const { t } = useI18n();

  const { readUsers, unreadUsers } = data;

  const lists = [
    {
      key: 1,
      label: `${t("announcement:read_by")}: ${_.size(readUsers)}`,
      users: readUsers,
    },
    {
      key: 2,
      label: `${t("announcement:not_read_by")}: ${_.size(unreadUsers)}`,
      users: unreadUsers,
    },
  ];

  return (
    <div className={classes.container}>
      <div
        className={classes.innerContainer}
        style={recipientModalPaddingStyles}
      >
        {_.map(lists, list => {
          const { key, label, users } = list;
          if (_.isEmpty(users)) return null;

          return (
            <div key={key}>
              <div className={classNames("heading-6", classes.listHeading)}>
                {label}
              </div>
              <ul className={classes.list}>
                {_.map(users, ({ user }) => {
                  const fullName = getFormattedNameForUserType({
                    user,
                    orderBy: defaultNameSortPreference,
                    defaultStudentNameOrderPreference,
                    isFormattedNameV2: true,
                  });

                  const avatarItem = {
                    id: user.id,
                    value: fullName,
                    imageUrl: user.profileImage,
                  };
                  const subtitle = getSubText({
                    loggedInUserRole: loggedInUserType,
                    messagedUserObj: user,
                    messagedUserRole: _.get(user, "type"),
                    t,
                  });

                  return (
                    <li className={classes.rowWrapper} key={user.id}>
                      <div className={classes.userInfo}>
                        <ProfileCascade
                          items={[avatarItem]}
                          showAvatar
                          avatarStyles={avatarStyles}
                          mainContainerStyle={profileCascadeContainerStyle}
                        />

                        <div className={classes.basicUserDetails}>
                          <p className={`text-body-1 ${classes.textEllipsis}`}>
                            {fullName}
                          </p>
                          {subtitle ? (
                            <p
                              className={`text-body-2 text-textSubtle ${classes.textEllipsis}`}
                            >
                              {subtitle}
                            </p>
                          ) : null}
                        </div>
                      </div>
                    </li>
                  );
                })}
              </ul>
            </div>
          );
        })}
      </div>
    </div>
  );
};

RecipientsList.propTypes = {
  data: PropTypes.shape({
    readUsers: PropTypes.arrayOf(PropTypes.object).isRequired,
    unreadUsers: PropTypes.arrayOf(PropTypes.object).isRequired,
  }).isRequired,
  defaultNameSortPreference: PropTypes.string.isRequired,
};

const mapStateToProps = state => {
  const userInfo = getUserInfo();
  const loggedInUserType = userInfo.user_type;
  return {
    defaultNameSortPreference: getDefaultNameSortPreference(state),
    defaultStudentNameOrderPreference: getDefaultStudentNameOrderPreference(
      state
    ),
    loggedInUserType,
  };
};

export default connect(mapStateToProps)(RecipientsList);
